export const incomeQuintileColors=['#C3ADA5','#AD8982','#986B69','#79464F','#552B3A'];
export const quadrantColors:Record<string,string>={
  lower_income_lower_access:'#A8AAA5',
  lower_income_higher_access:'#4D858A',
  higher_income_lower_access:'#C28A65',
  higher_income_higher_access:'#743C48'
};
